let hideBtnCols = function() {		
	this.colsDrop = false;
};
export default hideBtnCols;
